<template>
  <div class="setting">
    <van-nav-bar title="设置" left-arrow @click-left="onClickLeft" />
    <div class="setting-box">
      <van-uploader :before-read="beforeRead" :after-read="afterRead">
        <div class="setting-item flex-space-between">
          <p>头像</p>
          <div class="setting-item-right align-items-center">
            <div class="setting-item-right-img">
              <van-loading
                v-if="uploadLoading"
                class="uploadLoading"
                size="20px"
                color="#1989fa"
              />
              <img
                :src="
                  userInfo.headImage ||
                  require('../../../assets/images/account/userdefault.png')
                "
              />
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      </van-uploader>
      <div class="setting-item flex-space-between" @click="handleEdit('name')">
        <p>姓名</p>
        <div class="setting-item-right align-items-center">
          <p>{{ userInfo.name }}</p>
          <van-icon name="arrow" />
        </div>
      </div>
      <div
        class="setting-item flex-space-between"
        @click="handleEdit('nickname')"
      >
        <p>昵称</p>
        <div class="setting-item-right align-items-center">
          <p>{{ userInfo.nickname }}</p>
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="setting-item flex-space-between">
        <p>电话</p>
        <div class="setting-item-right">
          <!-- <p>{{userInfo.phone || ''}}</p> -->
          <p>{{ $store.state.userInfo.phone || "" }}</p>
        </div>
      </div>
      <div class="setting-item flex-space-between py0" v-if="isNewSaas && theme=='renshefenguan' && branchList.length>1">
        <p>切换机构</p>
        <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item @change="institutionClick_New" v-model="branchUcode" :options="branchList" :title="branchName" ></van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <div class="setting-item flex-space-between py0" v-else-if =" theme == 'renshefenguan' && branchList.length>1 ">
        <p>切换机构</p>
        <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item @change="institutionClick" v-model="branchId" :options="branchList" :title="branchName" ></van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>
    <div class="signOut" @click="handleSignOut">退出登录</div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import md5 from "js-md5";
export default {
  name: "setting",
  data() {
    return {
      uploadLoading: false,
      isReal: false,
      branchList:[],
      branchName:null,
      branchId:null,
      showVocationPicker:false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    /* 行业标签
            meet_emergency    应急
        */
		branchIndustry() {
			return this.$store.state.dynamic.pageSetData.branchIndustry
    },
    isNewSaas() {
      return this.$store.state.isNewSaas
    },
  },
  async created() {
    this.theme = this.$store.state.dynamic.theme;
    this.isRealNameAuthentication();
    if(this.$store.state.dynamic.theme == 'renshefenguan'){
      if(this.isNewSaas){
        this.getFindUserBranchList_New()
      }else{
        await this.getFindUserBranchList()
      }
    }
  },
  methods: {
    institutionClick_New(value){
      this.$api.account_new.switchBranch(value).then((res) => {
          if (res.success) {
              this.init()
              this.getAccountUserInfo_new()
              this.isadd = true
          }
      })
      this.branchList.forEach(async item => {
          if (item.value == value) {
              this.isadd = false
              this.branchUcode = item.value
              this.branchName = item.text
              localStorage.setItem('branchUcode',this.branchUcode)
              localStorage.setItem('branchName',this.branchName)
          }
      })
    },
    async institutionClick(value) {
      this.branchList.forEach(async item => {
        if (item.value == value) {
          this.isadd = false
          this.branchId = item.value
          this.branchName = item.text
          localStorage.setItem('code', item.code)
          localStorage.setItem('organ', item.organ)
          localStorage.setItem('actor', item.actor)
          localStorage.setItem('branch', item.value)
          item.channel && localStorage.setItem('channel', item.channel)
          setTimeout(async () => {
              this.init()
              this.getAccountUserInfo()
              this.isadd = true
          }, 500)
        }
      })
    },
     // 用户中心改造
    getFindUserBranchList_New () {
        let branchList = JSON.parse(localStorage.getItem('branchList'))
        if(branchList && branchList.length){
            this.branchList = branchList.map(item => ({
                text: item.name,
                value: item.ucode,
            }))
            this.branchUcode = localStorage.getItem('branchUcode')
            this.branchName = localStorage.getItem('branchName')
        }else{
            this.show = false
        }
    },
      async getFindUserBranchList () {
        this.getAccountUserInfo()
          return this.$api.account.getFindUserBranchList({}).then(res => {
            if (res.data && res.data.length) {
              this.branchList = res.data.filter(item => Object.prototype.toString.call(item) === '[object Object]').map(item => {
                  return {
                      text: item.name,
                      value: item.branch,
                      actor: item.actor,
                      organ: item.organ,
                      channel: item.channel,
                      code: item.code
                  }
              })
              this.show = true
              if (!this.branchList.length) return
              localStorage.setItem('branchList', JSON.stringify(this.branchList))
              if (localStorage.getItem('branch')) {
                  res.data.forEach(item => {
                      if (item.branch == localStorage.getItem('branch')) {
                          this.branchId = item.branch;
                          this.branchName = item.name
                      }
                  })
              } else {
                  this.branchId = res.data[0].branch;
                  this.branchName = res.data[0].name
              }
              !localStorage.getItem('code') && localStorage.setItem('code', res.data[0].code)
              !localStorage.getItem('organ') && localStorage.setItem('organ', res.data[0].organ)
              !localStorage.getItem('actor') && localStorage.setItem('actor', res.data[0].actor)
              !localStorage.getItem('branch') && localStorage.setItem('branch', res.data[0].branch)
              !localStorage.getItem('channel') && res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
              this.$sensors.login(res.data[0].code)
              this.isadd=true;
          } else {
              this.show = false
          }
      })
    },
    async getAccountUserInfo () {
      return this.$api.usercenter.getAccountUserInfo({}).then(res => {
          if (res.data) {
              this.$store.state.userInfo = {
                  ...this.$store.state.userInfo,
                  ...res.data
              }
              localStorage.setItem('WDuserInfo', JSON.stringify(this.$store.state.userInfo))
          }
      })
    },
    getAccountUserInfo_new(){
      this.$api.user_new.getUserInfo().then((res) => {
          if (res.success) {
              this.$store.commit('setUserInfo', res.data)
          }
      })
    },
    isRealNameAuthentication() {
      this.$api.exam.isRealNameAuthentication({}).then((data) => {
        const token = localStorage.getItem("token");
        this.isReal = data.code === 0 && md5(token + "true") === data.data;
      });
    },
    beforeRead(file) {
      this.uploadLoading = true;
      if (file.type.indexOf("image") === -1) {
        this.$notify({
          duration: 2000,
          type: "danger",
          message: "请上传正确格式的图片",
        });
        this.uploadLoading = false;
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("file", file.file);
      this.$api.user
        .upload(formData)
        .then(async (res) => {
          if (res.code == 0) {
            // 保存头像
            try {
              let result = await this.$api.user.updateUser({
                headImage: res.data,
              });
              if (result.success) {
                this.uploadLoading = false;
                this.userInfo.headImage = res.data;
                this.$store.commit("setUserInfo", { headImage: res.data });
              } else {
                this.uploadLoading = false;
              }
            } catch (error) {
              this.uploadLoading = false;
            }
          }
        })
        .catch((err) => {
          this.uploadLoading = false;
        });
    },
    handleSignOut() {
      const params = {
        token: localStorage.getItem("token") || null,
      };
      this.$api.account.logout({ params }).then((res) => {
        if (res.data) {
          const branchId = localStorage.getItem("branchId");
          const branchUcode = localStorage.getItem("branchUcode");
          const saasId = localStorage.getItem("saasId");
          const theme = localStorage.getItem("theme");
          const frontendConfig = localStorage.getItem('frontendConfig')
          const sfrontendConfig = sessionStorage.getItem('frontendConfig')
          localStorage.clear();
          sessionStorage.clear();
          this.$store.state.userInfo = {}
          localStorage.setItem("branchId", branchId);
          localStorage.setItem("branchUcode", branchUcode);
          localStorage.setItem("saasId", saasId);
          localStorage.setItem("theme", theme);
          localStorage.setItem('frontendConfig', frontendConfig)
          sessionStorage.setItem('frontendConfig', sfrontendConfig)          // 应急首页、登录定制化配置
          // 行业标签 meet_emergency    应急
          if(this.branchIndustry === 'meet_emergency'){
            this.$router.replace('/yj_training_options');
          }else{
            this.$router.replace("/login");
          }
        } else {
          this.$toast("退出失败");
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    handleEdit(type) {
      if (type === "name" && this.isReal) {
        this.$toast("已经实名认证过不允许修改姓名");
        return;
      }
      this.$router.push({
        path: "/edit",
        query: {
          type,
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
/deep/.van-dropdown-menu__bar{
    box-shadow:none;
  }
/deep/.van-popup{
    position absolute;
  }
}

.align-items-center {
  display: flex;
  align-items: center;
}

.setting {
  height: 100vh;
  background: #F7F7F7;
  position: relative;

  .signOut {
    width: 100%;
    height: 100px;
    background: #fff;
    margin-top: 30px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 100px;
  }

  .setting-box {
    padding: 0 30px;
    background: #fff;
    box-sizing: border-box;

    .van-uploader, /deep/ .van-uploader__wrapper, /deep/ .van-uploader__input-wrapper {
      width: 100%;
    }
  }
  .setting-item.py0{
    padding-top:0;
    padding-bottom:0;
  }
  .setting-item {
    padding: 34px 0;
    border-bottom: 1px solid #EAEAEA;
    p {
      font-size: 30px;
    }

    &:nth-child(1) {
      padding: 20px 0;
    }

    &:last-child {
      border-bottom: 0;
    }

    .setting-item-left {
      color: #333333;
    }

    .setting-item-right {
      .van-icon {
        color: #666;
        font-size: 13px;
        margin-left: 4px;
      }

      .setting-item-right-img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        position: relative;

        .uploadLoading {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          text-align: center;

          /deep/ .van-loading__spinner {
            margin-top: 15px;
          }
        }

        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }

      p {
        color: #666;
        font-size: 26px;
      }
    }
  }
}
</style>
